import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-repository-table-sort-menu', {
  mixins: [eventListenerMixin],

  connected() {
    this.form = this.querySelector('form');
    this.categoryField = this.querySelector('#tr_repository_repositories_order_category');
    this.sequenceField = this.querySelector('#tr_repository_repositories_order_sequence');
    this.folderField = this.querySelector('#tr_repository_repositories_order_folder_first');

    this.listenTo(this.querySelector('tr-menu'), 'tao:selected', (e) => {
      const { value } = e.detail.item.dataset;
      if (value === 'folder_first') {
        this.folderField.value = this.folderField.value === 'false';
      } else {
        this.categoryField.value = value;
        this.sequenceField.value = 'asc';
      }
      this.sumbit();
    });
  },

  updateSequence(category, sequence) {
    this.categoryField.value = category;
    this.sequenceField.value = sequence;
    this.sumbit();
  },

  sumbit() {
    this.form.dispatchEvent(
      new Event('submit', {
        bubbles: true,
        cancelable: true,
      }),
    );
  },

  disconnected() {
    this.stopListening();
  },
});
